/**
 * A single guide line dragged out from a ruler.
 */
export interface RulerLine {
  /** Unique identifier */
  readonly id: string;

  /** Orientation of the line */
  readonly axis: "horizontal" | "vertical";

  /**
   * Position in pixels relative to the target element's content edge.
   * - horizontal  → distance from the top
   * - vertical    → distance from the left
   */
  position: number;

  /** Optional snap target label rendered next to the coordinate. */
  targetLabel?: string;

  /** CSS selector to re-find the element this line is bound to. */
  targetSelector?: string;

  /** Which edge/center of the target this line tracks. */
  targetEdge?:
    | "top" | "bottom" | "center-y" | "left" | "right" | "center-x"
    | "col-left" | "col-right" | "col-center";
}

/**
 * Serialisable snapshot for one element.
 */
export interface RulerElementState {
  readonly elementId: string;
  lines: RulerLine[];
}

let _nextId = 0;
export function createRulerLineId(): string {
  return `ruler-${Date.now()}-${_nextId++}`;
}
